import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ExclamationCircleFilledSvg from "@ant-design/icons-svg/es/asn/ExclamationCircleFilled";
import AntdIcon from "../components/AntdIcon";
var ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExclamationCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ExclamationCircleFilled.displayName = 'ExclamationCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(ExclamationCircleFilled);